<section class="content">
  <div class="row">
    <div class="col-12" [ngClass]="!(profileState | async).loader['audit']['followerEngage'] ? 'background-loader' : ''">
      <div class="card">
        <div class="card-body">
          <div class="spinner" *ngIf="!(profileState | async).loader['audit']['followerEngage']"></div>
          <h3 class="card-header">
            Engagement rate by days
            <a data-tooltip="Average engagement rate - checked per day (graph showing dynamics in the last 30 days)">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </h3>
          <app-audit-no-mention type="chart" name="Engagement rate">
            <!--          <div class="spinner"></div>-->
            <div class="m--margin-top-20" *ngIf="chartsFollowerEngage !== undefined">
              <div [chart]="chartsFollowerEngage[0]"></div>
            </div>
          </app-audit-no-mention>
          <div class="report-results my-2" *ngIf="(profileState | async).followerEngage !== null">
            <div class="b-left mb-3 mb-sm-0">
              <h2>{{(profileState | async).followerEngage.engage_count | number:'1.2'}}%</h2>
              <p class="sub-text">Avg. engagement per Post</p>
            </div>
            <div class="b-left mb-3 mb-sm-0">
              <h2>{{(profileState | async).followerEngage.like_avg | number:'1.2'}}</h2>
              <p class="sub-text">Avg. likes per Post</p>
            </div>
            <div class="b-left mb-3 mb-sm-0">
              <h2>{{(profileState | async).followerEngage.comment_avg | number:'1.2'}}</h2>
              <p class="sub-text">Avg. comments per Post</p>
            </div>
            <div class="b-left">
              <h2>{{(profileState | async).followerEngage.share_avg | number:'1.2'}}</h2>
              <p class="sub-text">Avg. shares per Post</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
